import Vue from 'vue'
import "babel-polyfill"
import iView from 'iview';
import $ from 'jquery'
import ft from '@/filters/filters';
import 'iview/dist/styles/iview.css';
import '@/assets/css/common.css';

Vue.use(iView);

//注册全局过滤器
for(let key in ft){
  Vue.filter(key, ft[key]);
}

//弹框提示
window.alert = (msg)=>{
  Vue.prototype.$Modal.info({
    title: '提示',
    content: msg
  });
}
window.confirm = (msg,cb)=>{
  Vue.prototype.$Modal.confirm({
    title: '提示',
    content: msg,
    onOk: () => {
      cb(true);
    },
    onCancel: () => {
      cb(false);
    }
  });
}
Vue.prototype.$Message.config({
  top: 80,
  duration: 3
});
window.msgSuccess = (msg)=>{
  Vue.prototype.$Message.success(msg);
}
window.msgError = (msg)=>{
  Vue.prototype.$Message.error(msg);
}
window.msgWarning = (msg)=>{
  Vue.prototype.$Message.warning(msg);
}
Vue.prototype.$resize = (w, h)=>{
  return '?x-oss-process=image/resize,w_'+w+',h_'+h;
};

$(function () {
  var cp = window.location.pathname;
  var d = $(document);

  if(cp == "/" || cp == "/index.html" || cp =="/indexIE.html"){
    var b = $(".banner");
    var h = $(".header");
    var e = $(".shoot");
    var z = $(".zebra");
    var a = $(".advert");
    var cv = $(".create-video");

    h.removeClass("black");
    cv.removeClass("visi");

    window.onscroll = function () {
      var dh = d.scrollTop();
      var bh = b.offset().top + b.height();
      var eh = e.offset().top + e.height();

      //导航菜单
      if (dh >= bh) {
        h.addClass("black");
        cv.removeClass("visi");
      } else {
        h.removeClass("black");
        cv.addClass("visi");
      }

      //估价器
      if (dh >= eh) {
        z.removeClass("hide");
        a.removeClass("hide");
      } else {
        z.addClass("hide");
        a.addClass("hide");
      }

      //加载动画
      scrollfun();
    }
  }
});

function scrollfun(){
  //服务
  scrollacro('.service', '.service dl', 'acro-scale-visible');

  //案例
  var bigel = $('.case .list-big .item');
  bigel.each(function (i,e) {
    scrollacro('.case .list-big', bigel[i], 'acro-visible ' + 'acro-delay' + i);
  });

  var cel = $('.case .list .item');
  cel.each(function (i,e) {
    scrollacro('.case .list', cel[i], 'acro-visible ' + 'acro-delay' + i);
  });

  //制作人
  var pel = $('.producer .list .item');
  pel.each(function (i,e) {
    scrollacro('.producer .list', pel[i], 'acro-visible ' + 'acro-delay' + i);
  });

  //演员
  var ael = $('.artist .list .item');
  ael.each(function (i,e) {
    scrollacro('.artist .list', ael[i], 'acro-visible ' + 'acro-delay' + i);
  });

  //新闻
  var nel = $('.news .list .item');
  nel.each(function (i,e) {
    scrollacro('.news .list', nel[i], 'acro-visible ' + 'acro-delay' + i);
  });

  //品牌
  var bel = $('.brand ul li');
  bel.each(function (i,e) {
    if(i<5){
      scrollacro('.brand ul', e, 'acro-visible acro-delay1');
    } else if(i<10){
      scrollacro('.brand ul', e, 'acro-visible acro-delay2');
    } else if(i<15){
      scrollacro('.brand ul', e, 'acro-visible acro-delay3');
    } else {
      scrollacro('.brand ul', e, 'acro-visible acro-delay4');
    }

  });

}

function scrollacro(target, element, cssname){
  var b,c,d;

  if(element == ''){
    element = target;
  }

  d=$(target).offset().top;
  b=$(window).scrollTop();
  c=$(window).height();

  if((c/1.5+b) > d){
    $((element)).addClass((cssname));
  }
}




// WEBPACK FOOTER //
// ./src/assets/js/common.js